import axios from "axios";

const request = axios.create({
   url: '/ajax/',
   baseURL: '/api/controls/',
   headers: {'X-Requested-With': 'XMLHttpRequest'},
});

const complexId = document.querySelector( 'section.chooser.param' )?.getAttribute( 'data-complex-id' );

export const getInitialFiltersValue = () => {
	return request.post(`?complex=${complexId}`)
		.then( ( response ) => {
			return response.data;
		} );
};
